import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as n, createElementVNode as s } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconTags",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, f, a) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--tags"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Tags",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    s("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M.5 2.5A.5.5 0 0 1 1 2h3.5a.5.5 0 0 1 .354.146l3.145 3.145a1.713 1.713 0 0 1 0 2.418l-1.79 1.79a1.713 1.713 0 0 1-2.418 0L.646 6.354A.5.5 0 0 1 .5 6V2.5Zm1 .5v2.793L4.499 8.79a.713.713 0 0 0 1.002 0L7.291 7a.713.713 0 0 0 0-1.002L4.293 3H1.5Zm5.646-.854a.5.5 0 0 1 .708 0l3.149 3.15a1.702 1.702 0 0 1 0 2.408m0 0-2.15 2.15a.5.5 0 0 1-.707-.708l2.15-2.15h.001a.7.7 0 0 0 0-.992l-3.15-3.15a.5.5 0 0 1 0-.708M3 4a.5.5 0 0 1 .5.5v.005a.5.5 0 0 1-1 0V4.5A.5.5 0 0 1 3 4Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, m);
}
const v = /* @__PURE__ */ o(c, [["render", u]]);
export {
  v as default
};
//# sourceMappingURL=tags.js.map
